import i18next from 'i18next'
import * as React from 'react'
import { any, fromJSX, IOWidget, Updater } from 'widgets-for-react'
import { TextPageHeader } from '../../pageHeader/pageHeaderLayout'
import { paginationWidget } from '../../pagination/paginationWidget'
import { blogTeasersWidget } from '../blogTeasers/blogTeasersWidget'
import {
  BlogOverviewState,
  blogOverviewStateUpdaters,
} from './blogOverviewState'

export const blogsPerPage = 10

export const blogOverviewWidget =
  (page: number): IOWidget<BlogOverviewState, Updater<BlogOverviewState>> =>
  (blogOverviewState) =>
    any([
      fromJSX(() => (
        <TextPageHeader
          title={i18next.t('blog:blogsTitle')}
          intro={i18next.t('blog:blogsIntro')}
        />
      )),
      blogTeasersWidget(
        'overview-page',
        i18next.t('blog:blogsTitle_plural')
      )(blogOverviewState.blogTeasersState).map(
        blogOverviewStateUpdaters.updateBlogTeasersState
      ),
      paginationWidget(page - 1, blogsPerPage, (newPage: number) =>
        i18next.language == 'en'
          ? `/en/blog?page=${newPage + 1}`
          : `/nl/blog?page=${newPage + 1}`
      )(blogOverviewState.paginationState).map(
        blogOverviewStateUpdaters.updatePaginationState
      ),
    ])
